module.exports = __webpack_public_path__ + "static/media/khetika.09e6cd12.png";